// Serialize a JSON-LD object for an inline <script> block. JSON.stringify
// alone does NOT escape "<", so a value containing "</script>" would
// terminate the script element and inject markup into the page (stored XSS
// via template/guide text). < is valid JSON, so parsers and Google's
// structured-data tooling read it identically.
export const jsonLdString = (obj: unknown): string =>
    JSON.stringify(obj).replace(/</g, "\\u003c");
